<template>
  <section>
    <div class="d-flex flex-column align-md-center flex-md-row mb-4">
      <div>
        <h3 v-if="title || $slots.title" class="display-1 font-weight-bold">
          <slot name="title">
            {{ title }}
          </slot>
        </h3>
        <p v-if="subtitle || $slots.subtitle" class="body-2 mb-0">
          <slot name="subtitle">
            {{ subtitle }}
          </slot>
        </p>
      </div>

      <div v-if="$slots.actions" class="ml-md-auto pt-4 pt-md-0">
        <slot name="actions" />
      </div>
    </div>
    <slot />
  </section>
</template>

<script>
export default {
  props: {
    title: { type: String, required: false },
    subtitle: { type: String, required: false },
  },
}
</script>
